export default __webpack_public_path__ + "static/media/AboutUs.7d5644e8.png";